export const etherVoxApiUrl = 'https://api.ethervox.io';
export const etherVoxApiContext = 'api/v3';
export const etherVoxCarrierPath = '/io/public';
export const protectedSocketPath = '/socket.io';
export const dashboardApiUrl = 'https://ev-symphony-dashboard-api.gltd.net';
